module.exports = __webpack_public_path__ + "static/media/confetti.b9b82b7b.png";